import { AnalyticTrackingBasePropertiesObj, TrackingGeneralProp } from './AnalyticTrackingBasePropertiesObj';
import { PageName, PageType } from '@utils/pageConfig/Types';
import { getCountryFromSideFilters, getProductGroupFromSideFilters } from '@utils/FilterUtils';
import { concatenateSelectedFeatureName, doAmplitudeAnalyticsTracking } from '../PageAnalytics';

/**
 -----Create Category Group Tracking---------

 analytics.track("Table Clicked", {
 "access": "Retail Insights",
 "locationID": "Germany",
 "tableName": "Category Leaderboard", // the name of the table
 "elementName": "Create Category Group",
 "elementType": "Table Category Group",
 "optionChosen": "PTV/FLAT,COOLING,COOKING",
 "pageName": "Category Leaderboard",
 "itemGroup": "All",
 "section": "Retail Intelligence",
 "subsection": "Category Leaderboard"})

 -----Add product group(s) to group Tracking----

 analytics.track("Table Clicked", {
 "access": "Retail Insights",
 "locationID": "Germany",
 "tableName": "Category Leaderboard", // the name of the table
 "elementName": "Add Category Group",
 "elementType": "Table Category Group",
 "optionChosen": "PTV/FLAT,COOLING", --Category group that selected by user for grouping
 "pageName": "Category Leaderboard",
 "itemGroup": "All", - Side filter Product Group, if there is no Product Group selected then will be sent as "All"
 "section": "Retail Intelligence",
 "subsection": "Category Leaderboard"})

 ----------Delete product group Tracking------

 analytics.track("Table Clicked", {
 "access": "Retail Insights",
 "locationID": "Germany",
 "tableName": "Category Leaderboard", // the name of the table
 "elementName": "Delete Category Group",
 "elementType": "Table Category Group",
 "optionChosen": "PTV/FLAT", --Category group that selected by user for grouping
 "pageName": "Category Leaderboard",
 "itemGroup": "All", - Side filter Product Group, if there is no Product Group selected then will be sent as "All"
 "section": "Retail Intelligence",
 "subsection": "Category Leaderboard"})


 ------Delete Group Tracking------------

 analytics.track("Table Clicked", {
 "access": "Retail Insights",
 "locationID": "Germany",
 "tableName": "Category Leaderboard", // the name of the table
 "elementName": "Delete Category Group",
 "elementType": "Table Category Group",
 "optionChosen": "Group1", --Category group that selected by user for grouping / Group name that deleted
 "pageName": "Category Leaderboard",
 "itemGroup": "All", - Side filter Product Group, if there is no Product Group selected then will be sent as "All"
 "section": "Retail Intelligence",
 "subsection": "Category Leaderboard"})

 **/

export const CATEGORY_GROUP_TABLE_ELEMENT_CLICKED_TITLE = 'Table Clicked';
export const PRODUCT_LEADERBOARD_TABLE_ELEMENT_CLICKED_TITLE = 'Table Clicked';
export const PRODUCT_LEADERBOARD_TABLE_NAME = 'Top Selling Products';
export const OPPORTUNITY_REVIEW_TABLE_ELEMENT_CLICKED_TITLE = 'Table Clicked';

export interface GroupElementClickedTracking extends AnalyticTrackingBasePropertiesObj {
  tableName: string;
  optionChosen: string;
  elementName: string;
  elementType: string;
}

export interface TableElementClickedParam {
  elementName: string;
  elementType: string;
  optionChosen: string;
  pageName: PageName;
  pageType: PageType;
  track: (event: string, properties?: Object) => void;
  eventTitle: string;
  sideFilters: any;
  tableName?: string;

  access: Object;
}

export const groupElementClickedTrackingFunction = (param: TableElementClickedParam) => {
  const {
    sideFilters,
    pageName,
    pageType,
    track,
    eventTitle,
    optionChosen,
    elementName,
    elementType,
    tableName,
    access,
  } = param;

  const selectedSideFilter = sideFilters[pageType];
  const appliedProductGroup = getProductGroupFromSideFilters(selectedSideFilter);
  const appliedFiltersCountry = getCountryFromSideFilters(selectedSideFilter);
  const tableNameTrack = tableName ?? pageName;

  const pageElementViewProperties: GroupElementClickedTracking = {
    access: access,
    locationId: appliedFiltersCountry?.options.map((options) => options.label),
    tableName: tableNameTrack,
    elementName: elementName,
    elementType: elementType,
    optionChosen: optionChosen,
    pageName: pageName,
    itemGroup: concatenateSelectedFeatureName(appliedProductGroup),
    section: TrackingGeneralProp.SECTION_TRACKING_PROP,
    subsection: pageName,
  };

  doAmplitudeAnalyticsTracking(eventTitle, track, pageElementViewProperties);
};
